import { CREATE_DRAWER_START } from "../../types";

export const create_drawer = (payload) => ({
  type: CREATE_DRAWER_START,
  payload,
});
